import script from "./dyloading.vue?vue&type=script&setup=true&lang=js"
export * from "./dyloading.vue?vue&type=script&setup=true&lang=js"

import "./dyloading.vue?vue&type=style&index=0&id=381310dc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-381310dc"]])

export default __exports__